import React from 'react';

import { BaseButton, useT } from '@repo/common';
import ResumeTitle from './ResumeTitle';

import { ReactComponent as ArrowLeftIcon } from '@repo/common/assets/icons/24px/icon_24px_arrow-left.svg';
import { ReactComponent as ArrowLeftIcon20 } from '@repo/common/assets/icons/20px/icon_20px_arrow-left.svg';

const StepToolbar = ({
  onNext,
  onBack,
  onSaveDraft,
  onSave,
  resumeData,
  resumeTitle,
  setResumeTitle,
  currentStep,
  totalSteps,
}) => {
  const t = useT();
  const isLastStep = currentStep === totalSteps - 1;
  const primaryLabel = !isLastStep ? t('Next', '다음') : t('Save', '저장');

  return (
    <div
      className='
        w-full
        flex flex-row items-center justify-between
        h-11 tabletH:h-16 desktopL:h-[54px]
        px-4 py-[7px] tabletH:px-6 tabletH:py-3 desktopL:px-20 desktopL:py-2
        sticky top-0
        bg-grayscale-gray00
        z-20
        border-b border-grayscale-gray02
        overflow-hidden
      '
    >
      <div className='flex h-full shrink-0 items-center gap-1 tabletH:gap-0'>
        <button
          type='button'
          className='flex size-6 items-center justify-center text-grayscale-gray09 tabletH:h-[38px] tabletH:w-10'
          onClick={onBack}
          aria-label={t('Go back', '뒤로 가기')}
        >
          <ArrowLeftIcon20 className='size-5 tabletH:hidden' />
          <ArrowLeftIcon className='hidden size-6 tabletH:block' />
        </button>

        <div className='hidden h-[38px] items-center justify-center pr-6 tabletH:flex'>
          <span className='typo-b18Strong text-text-primary !font-medium'>
            {t('Create Resume', '이력서 작성')}
          </span>
        </div>
      </div>

      <div className='flex min-w-0 flex-1 items-center justify-center px-2 tabletH:justify-end tabletH:px-0'>
        <ResumeTitle
          resumeData={resumeData}
          title={resumeTitle}
          setTitle={setResumeTitle}
        />
      </div>

      <div className='flex shrink-0 flex-row items-center gap-2'>
        <button
          type='button'
          className='typo-b14Strong whitespace-nowrap text-green-deep02 !font-medium tabletH:hidden'
          onClick={isLastStep ? onSave : onNext}
        >
          {primaryLabel}
        </button>

        <BaseButton
          type='text'
          size='m'
          hideIcon
          rounded='pill'
          textclass='!font-medium tracking-[0]'
          className='!rounded-[99px] hidden tabletH:inline-flex'
          onClick={onSaveDraft}
        >
          {t('Save draft', '임시 저장')}
        </BaseButton>
        <BaseButton
          size='m'
          hideIcon
          width='80px'
          rounded='pill'
          textclass='!font-medium tracking-[0]'
          className='!rounded-[99px] hidden tabletH:inline-flex'
          onClick={() => {
            if (isLastStep) {
              onSave();
            } else {
              onNext();
            }
          }}
        >
          {primaryLabel}
        </BaseButton>
      </div>
    </div>
  );
};

export default StepToolbar;
